export default "__VITE_ASSET__Bu_IraF0__";